// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__mCl5r","footer":"ChangeClinic_footer__2vEkM"};